import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Solar from "@/pages/Solar";
import SolarCalculator from "@/pages/SolarCalculator";
import Mining from "@/pages/Mining";
import Media from "@/pages/Media";
import Gallery from "@/pages/Gallery";
import Operations from "@/pages/Operations";
import Investors from "@/pages/Investors";
import ESG from "@/pages/ESG";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import AccessPortal from "@/pages/AccessPortal";
import Account from "@/pages/Account";
import Download from "@/pages/Download";
import CustomPage from "@/pages/CustomPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ContentManager from "@/pages/admin/ContentManager";
import MediaManager from "@/pages/admin/MediaManager";
import Messages from "@/pages/admin/Messages";
import Applications from "@/pages/admin/Applications";
import VisitorLogs from "@/pages/admin/VisitorLogs";
import Projects from "@/pages/admin/Projects";
import SiteEditor from "@/pages/admin/SiteEditor";
import RolesAudit from "@/pages/admin/RolesAudit";

function ProtectedRoute({ children }) {
  const { user, authReady } = useApp();
  if (!authReady) return <div className="min-h-screen grid place-items-center bg-[#FFFFFF] text-teal-400 font-mono text-sm">Authenticating…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/solar" element={<Solar />} />
        <Route path="/solar-calculator" element={<SolarCalculator />} />
        <Route path="/mining" element={<Mining />} />
        <Route path="/media" element={<Media />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/operations" element={<Operations />} />
        <Route path="/investors" element={<Investors />} />
        <Route path="/esg" element={<ESG />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/access-portal" element={<AccessPortal />} />
        <Route path="/account" element={<Account />} />
        <Route path="/download" element={<Download />} />
        <Route path="/p/:slug" element={<CustomPage />} />
      </Route>

      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="content" element={<ContentManager />} />
        <Route path="media" element={<MediaManager />} />
        <Route path="messages" element={<Messages />} />
        <Route path="applications" element={<Applications />} />
        <Route path="visitors" element={<VisitorLogs />} />
        <Route path="projects" element={<Projects />} />
        <Route path="site-editor" element={<SiteEditor />} />
        <Route path="roles" element={<RolesAudit />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" theme="dark" richColors />
      </BrowserRouter>
    </AppProvider>
  );
}
